// extracted by mini-css-extract-plugin
export default {"base":"RelatedProjects-module--base--9e875","rule":"RelatedProjects-module--rule--80b75"};